import { Helper } from '../../../js/util/helper';

export default class Mainnavigation {
  constructor( node ) {
    this.node = node;
    this.slideLinks = node.querySelectorAll( '.js-mainnavigation-item' );
    this.backLinks = node.querySelectorAll( '.js-mainnavigation-back' );
    this.flyout = node.querySelector( '.mainnavigation__flyout' );
    this.flyoutClose = node.querySelector( '.js-mainnavigation-close' );
    this.activeClass = 'mainnavigation__sublist--active';
    this.handleEvents();
    this.showInitialExpandedSublist();
  }
  showInitialExpandedSublist() {
    let index = 0;
    let nav = this.node.querySelector( '.mainnavigation__nav' );
    // use recursion to finde the active & current list
    let increaseIndex = parent => {
      let active = parent.querySelector( '.mainnavigation__sublist--active' );
      if ( active ) {
        index--;
        increaseIndex( active );
      } else if ( index < 0 ) {
        nav.setAttribute( 'data-slide-index', index );
        parent.classList.add( '.mainnavigation__sublist--current' );
      }
    };
    // start recursion
    increaseIndex( this.flyout );
  }
  handleEvents() {
    [ ...this.slideLinks ].forEach( link => {
      link.querySelector( 'a' ).addEventListener( 'click', event => {
        this.slideList( event );
        document.body.dispatchEvent( new CustomEvent( 'open-header-flyout' ));
      });
    });
    [ ...this.backLinks ].forEach( link => {
      link
        .querySelector( 'a' )
        .addEventListener( 'click', this.slideBack.bind( this ));
    });
    window.addEventListener( 'click', ( e ) => {
      if ( e.target === this.flyout && e.target.classList.contains( 'mainnavigation__flyout--active' )) {
        this.removeActive();
      }
    });
    this.flyoutClose.addEventListener( 'click', this.removeActive.bind( this ));
    // close flyout if search has been opened
    document.body.addEventListener( 'open-search', event => {
      this.removeActive();
    });
  }
  slideList( event ) {
    event.preventDefault();
    let main = Helper.getClosest( event.target, '.mainnavigation' );
    let nav = main.querySelector( '.mainnavigation__nav' );
    let index = nav.getAttribute( 'data-slide-index' );
    let item = Helper.getClosest( event.target, '.js-mainnavigation-item' );
    let parent = item.parentNode;
    let id = item.getAttribute( 'aria-owns' );
    let sublist = document.querySelector( '#' + id );
    let currentList = main.querySelector( '.mainnavigation__sublist--current' );
    let flyoutContent = Helper.getClosest( sublist, '.mainnavigation__flyout-content' );
    let activeFlyoutContent = main.querySelector( '.mainnavigation__flyout-content--active' );
    let activeFlyoutHeight = null;

    if ( flyoutContent !== activeFlyoutContent && activeFlyoutContent ) {
      activeFlyoutHeight = activeFlyoutContent.getBoundingClientRect().height;
      activeFlyoutContent.classList.remove( 'mainnavigation__flyout-content--active' );
      this.removeActive();
    }

    if ( item.classList.contains( 'mainnavigation__item--active' ) && this.flyout.classList.contains( 'mainnavigation__flyout--active' )) {
      this.removeActive();
    } else {
      this.setActiveLink( main, item );
      this.setActiveList( main, parent, currentList, sublist );
      this.flyout.classList.add( 'mainnavigation__flyout--active' );
      flyoutContent.classList.add( 'mainnavigation__flyout-content--active' );
      nav.setAttribute( 'data-slide-index', parseInt( index ) - 1 );
    }

    // update flyout height between main links
    if ( flyoutContent !== activeFlyoutContent && activeFlyoutContent ) {
      let flyoutContentHeight = flyoutContent.getBoundingClientRect().height;
      flyoutContent.style.height = activeFlyoutHeight + 'px';
      setTimeout(() => flyoutContent.style.height = flyoutContentHeight + 'px', 250 );
    }
  }
  removeActive() {
    let main = Helper.getClosest( this.flyout, '.mainnavigation' );
    let activeList = main.querySelector( '.mainnavigation__sublist--active' );
    let activeLink = main.querySelector( '.mainnavigation__item--active' );
    let activeSubLink = this.flyout.querySelector( '.mainnavigation__subitem--active' );

    main.querySelectorAll( '.mainnavigation__flyout-content' ).forEach(( node ) => {
      node.style.removeProperty( 'height' );
    });

    if ( activeList ) {
      activeList.classList.remove( 'mainnavigation__sublist--active' );
    }
    if ( activeLink ) {
      activeLink.classList.remove( 'mainnavigation__item--active' );
    }
    if ( activeSubLink ) {
      activeSubLink.classList.remove( 'mainnavigation__subitem--active' );
    }
    this.flyout.classList.remove( 'mainnavigation__flyout--active' );
  }
  setActiveList( main, parent, currentList, sublist ) {
    let active = null;
    if ( parent.classList.contains( 'mainnavigation__list' )) {
      active = main.querySelectorAll( '.mainnavigation__sublist--active' );
    } else {
      active = parent.querySelectorAll( '.mainnavigation__sublist--active' );
    }
    if ( active ) {
      active.forEach( a => {
        a.classList.remove( 'mainnavigation__sublist--active' );
      });
    }
    if ( currentList ) {
      currentList.classList.remove( 'mainnavigation__sublist--current' );
    }
    sublist.classList.add( 'mainnavigation__sublist--active' );
    sublist.classList.add( 'mainnavigation__sublist--current' );

    // update height if sublist is higher than parent list
    this.setFlyoutHeight( currentList, sublist );
  }
  setFlyoutHeight( currentList, sublist ) {
    let flyoutContent = Helper.getClosest( currentList, '.mainnavigation__flyout-content' );
    if ( flyoutContent ) {
      let flyoutStyledHeight = flyoutContent.style.height;

      if ( flyoutStyledHeight ) {
        flyoutContent.style.removeProperty( 'height' );
      }

      let flyoutHeight = flyoutContent.getBoundingClientRect().height;
      let sublistHeight = sublist.getBoundingClientRect().height;
      let flyoutStyle = window.getComputedStyle( flyoutContent );
      let padding = parseInt( flyoutStyle.paddingBottom ) + parseInt( flyoutStyle.paddingTop );

      if ( sublistHeight + padding > flyoutHeight ) {
        flyoutContent.style.height = flyoutStyledHeight || flyoutHeight + 'px';
        setTimeout(() => {
          flyoutContent.style.height = ( sublistHeight + padding ) + 'px';
        }, 50 );
      }
    }
  }
  setActiveLink( main, item ) {
    if ( item.classList.contains( 'mainnavigation__item' )) {
      let active = main.querySelector( '.mainnavigation__item--active' );
      if ( active ) {
        active.classList.remove( 'mainnavigation__item--active' );
      }
      item.classList.add( 'mainnavigation__item--active' );
    } else {
      let active = main.querySelector( '.mainnavigation__subitem--active' );
      if ( active ) {
        active.classList.remove( 'mainnavigation__subitem--active' );
      }
      item.classList.add( 'mainnavigation__subitem--active' );
    }
  }
  slideBack( event ) {
    event.preventDefault();
    let currentList = Helper.getClosest(
      event.target,
      '.mainnavigation__sublist'
    );
    let parentList = Helper.getClosest(
      currentList.parentNode,
      '.mainnavigation__sublist'
    );
    let main = Helper.getClosest( event.target, '.mainnavigation' );
    let item = Helper.getClosest( event.target, '.mainnavigation__subitem--active' );
    let mainList = main.querySelector( '.mainnavigation__nav' );
    let index = mainList.getAttribute( 'data-slide-index' );

    // remove active state from list item
    // is sublist
    if ( item ) {
      item.classList.remove( 'mainnavigation__subitem--active' );
    // is mainlist
    } else {
      let id = currentList.getAttribute( 'id' );
      let mainItem = mainList.querySelector( '[aria-owns="' + id + '"]' );
      if ( mainItem ) {
        mainItem.classList.remove( 'mainnavigation__item--active' );
      }
    }

    mainList.setAttribute( 'data-slide-index', parseInt( index ) + 1 );
    currentList.classList.remove( 'mainnavigation__sublist--active' );
    currentList.classList.remove( 'mainnavigation__sublist--current' );
    if ( parentList ) {
      parentList.classList.add( 'mainnavigation__sublist--current' );
    } else {
      this.flyout.classList.remove( 'mainnavigation__flyout--active' );
    }
  }
}
